import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

//Admin Pages

import Dashboard from "./pages/adminpages/Dashboard";
import SettingPage from "./pages/adminpages/Setting";
import ProfilePage from "./pages/adminpages/Profile";

import VarifyRequest from "./pages/adminpages/buyer/VerifyRequestPage";
import BuyerListPage from "./pages/adminpages/buyer/BuyerListPage";
import VerifyRequestPage from "./pages/adminpages/buyer/VerifyRequestPage";
import BuyerSingleViewPage from "./pages/adminpages/buyer/BuyerSingleView";
import CreateListingsPage from "./pages/adminpages/CreateListingsPage";
import CategoryListPage from "./pages/adminpages/category/CategoryListPage";
import CreateCategoryPage from "./pages/adminpages/category/CreateCategoryPage";


import GroupListPage from "./pages/adminpages/group/GroupListPage";
import GroupBuyer from "./pages/adminpages/group/GroupSingleViewPage";

import CreateManagerPage from "./pages/adminpages/manager/CreateManagerPage";
import EditManagerPage from "./pages/adminpages/manager/EditManagerPage";
import ManagerListPage from "./pages/adminpages/manager/ManagerListPage";
import ManagerSingleViewPage from "./pages/adminpages/manager/ManagerSingleViewPage";

//Manager Pages
import ManagerDashboardPage from "./pages/managerPage/ManagerDashboardPage";
import SettingsPage from "./pages/managerPage/SettingsPage";

//Common Pages

import SurveyorListPage from "./pages/common/surveyor/SurveyorListPage";
import SurveyorCreatePage from "./pages/common/surveyor/SurveyorCreatePage";
import SurveyorEditPage from "./pages/common/surveyor/SurveyorEditPage";
import SurveyorSingleViewPage from "./pages/common/surveyor/SurveyorSingleViewPage";
import SurveyListPage from "./pages/common/surveys/SurveyListPage";
import SurveyCreatePage from "./pages/common/surveys/SurveyCreatePage";
import SurveyEditPage from "./pages/common/surveys/SurveyEditPage";
import SurveyAssignPage from "./pages/common/surveys/SurveyAssignPage";
import SurveySingleViewPage from "./pages/common/surveys/SurveySingleViewPage";
import BidListPage from "./pages/common/bids/BidListPage";
import BidDetailedViewPage from "./pages/common/bids/BidDetailedViewPage";
import BidRequestPage from "./pages/common/bids/BidRequestPage";

//Auth Pages
import LoginProtect from "./auth/LoginRouteProtect";
import LoginPage from "./pages/Auth/LoginPage";
import AdminRouteProtect from "./auth/AdminRouteProtect";
import ManagerRouteProtect from "./auth/ManagerRouteProtect";
import CommonRouteProtect from "./auth/CommonRouteProtect";
import BidApprovePage from "./pages/common/bids/BidApprovePage";
import NotificationPage from "./pages/common/notification/NotificationPage";
import useAuthStore from "./store/authStore";
import useStateStore from "./store/stateStore";
import Message from "./components/firebase/message/Message";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onMessageListener } from "./components/firebase/firebaseConfig";
import ViewBidsPage from "./pages/common/bids/ViewBidsPage";
import SurveySettlementPage from "./pages/common/surveys/SurveySettlementPage";

function App() {

  const { fetchNotifications } = useStateStore();
  const { user } = useAuthStore();
  const userId = user?._id

  onMessageListener()
    .then(async (payload) => {
      console.log("Received foreground message:", payload);

      // Check if notification exists in payload
      if (payload && payload.notification) {
        toast(<Message notification={payload.notification} />);
        await fetchNotifications(null, null, userId)

      } else {
        console.warn("No notification found in payload");
      }
    })
    .catch((err) => {
      console.error("Error in message listener:", err);
    });




  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<LoginProtect />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
          <Route element={<AdminRouteProtect />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/create-bid" element={<CreateListingsPage />} />

            <Route path="/buyer-list" element={<BuyerListPage />} />
            <Route
              path="/buyer-verify-request"
              element={<VerifyRequestPage />}
            />
            <Route
              path="/buyer-single-view"
              element={<BuyerSingleViewPage />}
            />

            <Route path="/group-single-view" element={<GroupBuyer />} />
            <Route path="/group-list" element={<GroupListPage />} />
            <Route path="/manage-content" element={<ProfilePage />} />

            <Route path="/manager-list" element={<ManagerListPage />} />
            <Route path="/manager-create" element={<CreateManagerPage />} />
            <Route path="/manager-edit" element={<EditManagerPage />} />
            <Route
              path="/manager-single-view"
              element={<ManagerSingleViewPage />}
            />

            <Route path="/varifyRequest" element={<VarifyRequest />} />

            <Route path="/setting" element={<SettingPage />} />
          </Route>

          <Route element={<ManagerRouteProtect />}>
            <Route path="/manager" element={<ManagerDashboardPage />} />

            <Route path="/manager/settings" element={<SettingsPage />} />
          </Route>
          <Route element={<CommonRouteProtect />}>
            <Route path="/bid-list" element={<BidListPage />} />
            <Route
              path="/bid-detailed-view"
              element={<BidDetailedViewPage />}
            />
            <Route path="/bid-approve" element={<BidApprovePage />} />
            <Route path="/bid-request" element={<BidRequestPage />} />

            <Route path="/survey-list" element={<SurveyListPage />} />
            <Route path="/survey-create" element={<SurveyCreatePage />} />
            <Route path="/survey-update" element={<SurveyEditPage />} />
            <Route path="/survey-assign" element={<SurveyAssignPage />} />
            <Route path="/survey-settlement" element={<SurveySettlementPage />} />
            <Route
              path="/survey-single-view"
              element={<SurveySingleViewPage />}
            />

            <Route path="/surveyor-list" element={<SurveyorListPage />} />
            <Route path="/surveyor-create" element={<SurveyorCreatePage />} />
            <Route path="/surveyor-edit" element={<SurveyorEditPage />} />
            <Route
              path="/surveyor-single-view"
              element={<SurveyorSingleViewPage />}
            />
            <Route path="/notifications" element={<NotificationPage />} />
            <Route path="/view-bids" element={<ViewBidsPage />} />
            <Route path="/category" element={<CategoryListPage />} />
            <Route path="/create-category" element={<CreateCategoryPage />} />

          </Route>
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
